import script from "./XIA-SearchBar.vue?vue&type=script&setup=true&lang=js"
export * from "./XIA-SearchBar.vue?vue&type=script&setup=true&lang=js"

import "./XIA-SearchBar.vue?vue&type=style&index=0&id=7a50a291&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a50a291"]])

export default __exports__